import styled from 'styled-components';
import {mobileMedia, WHITE, LIGHT_GRAY2, BGImageCenter, scrollbar} from '../../globalVariables/GlobalVariables';
import {alignCenter, dFlexEnd} from '../../globalVariables/GlobalFlex';
import {popUpBody} from '../newPopup/mobilePopup/MobilePopup.css';
import {btn} from '../button/btn/Btn.css';
import {container as innerPopContainer, bottom as innerPopBottom, close} from '../newPopup/innerPop/InnerPop.css';
import {arrowDark} from '../../assets/symbols/symbols/Symbols.css';

export const wrapper = styled.div`
    ${mobileMedia}{
        padding: 12px 0 0 0;
    }
    ${innerPopContainer} {
        &.show {
            width: 100%;
            height: 100%;
            max-height: 100%; 
        }
    }
    ${innerPopBottom} {
        gap: 10px;
        ${dFlexEnd};
        padding-inline-end: 20px;
    }
    ${popUpBody}{
        max-width: 680px;
    }
    ${close}{
        ${BGImageCenter(arrowDark,'16px')}
    }
`;

export const content = styled.div`
    padding: 20px 80px;
    inset-block-start: 60px;
    height: calc(100% - 60px);
    position: relative;
    ${scrollbar}
    ${mobileMedia}{
        padding: 0px 40px;
    }
`;

export const title = styled.div`
    font-size: 18px;
    font-weight: 600;
    line-height: 112%;
    letter-spacing: -0.18px;
    margin-bottom: 16px;
`;

export const list = styled.div`
    font-size: 13px;
    font-weight: 400;
    line-height: 149%;
    letter-spacing: -0.13px;
`;

export const item = styled.div`
    margin-bottom: 16px;
`;

export const subList = styled.div`
    padding-right: 20px;
    margin-top: 8px;
`;

export const subItem = styled.div`
    & > span {
        margin-left: 8px;
    }
    margin-bottom: 8px;
`;

export const note = styled.div`
    font-size: 13px;
    line-height: 149%;
    letter-spacing: -0.13px;
`;

export const actions = styled.div`
    width: 100%;
    border-top: 1px solid ${LIGHT_GRAY2};
    ${dFlexEnd};
    ${alignCenter};
    gap: 8px;
    background-color: ${WHITE};
    flex-shrink: 0;
    padding-inline: 24px;
    box-sizing: border-box;
    border-bottom-left-radius: 16px;
    border-bottom-right-radius: 16px;
    min-height: 70px;
    ${btn}{
        margin: 0;
        padding: 12px 25px;
        font-weight: 700;
    }
    ${mobileMedia}{
        padding: 16px 8px;
        min-height: 56px;
        position: sticky;
        bottom: 0;
    }
`;
